import PropTypes from 'prop-types'
import { Checkbox, Form, theme } from 'antd'

const InlineCheckbox = ({
  className = '',
  onChange = () => {},
  label,
  legend,
  name,
  isRequired = false,
  value = false,
  wrapperClass = '',
  errorHelp = false,
  errorMsg = '',
}) => {
  const { token } = theme.useToken()

  return (
    <>
      <fieldset className={wrapperClass}>
        {legend && (
          <legend>
            {isRequired && <span style={{ color: token.colorError }}>* </span>}
            {legend}
          </legend>
        )}
        <Form.Item
          name={name}
          valuePropName="checked"
          rules={
            isRequired
              ? [
                  {
                    validator: (_, checked) => {
                      if (checked) {
                        return Promise.resolve()
                      }
                      return Promise.reject(new Error(`"${label}" is required`))
                    },
                  },
                ]
              : undefined
          }
          {...(errorHelp === false ? { help: '' } : {})}
          validateStatus={errorHelp ? 'error' : undefined}
        >
          <Checkbox
            className={className}
            checked={value}
            onChange={(e) => {
              onChange(e.target.checked)
            }}
          >
            {label}
          </Checkbox>
        </Form.Item>
      </fieldset>
    </>
  )
}

InlineCheckbox.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  legend: PropTypes.string,
  name: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
  value: PropTypes.bool,
  wrapperClass: PropTypes.string,
  errorHelp: PropTypes.bool,
  errorMsg: PropTypes.string,
}

export default InlineCheckbox
